export interface SendContactEmailInput {
  email: string;
  phone?: string;
  topic: string;
}

export async function sendContactEmail(
  input: SendContactEmailInput,
): Promise<void> {
  const response = await fetch("/api/trpc/emailRouter.sendEmail", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      email: input.email,
      phone: input.phone ?? "",
      topic: input.topic,
    }),
  });

  const data = await response.json();

  if (!response.ok || data.error) {
    throw new Error(data.error?.message ?? "Failed to send contact email");
  }
}
